import { useEffect, useState } from "react";
import { Loader2, Check } from "lucide-react";

const steps = [
    "Uploading manuscript",
    "Processing document",
    "Mapping research network",
    "Computing novelty signals",
];

export default function UploadLoading({ onDone }) {
    const [currentStep, setCurrentStep] = useState(0);
    const lastIndex = steps.length - 1;

    useEffect(() => {
        const delay = currentStep === lastIndex ? 6000 : 3000;
        const timer = setTimeout(() => {
            if (currentStep < lastIndex) {
                setCurrentStep(s => s + 1);
            } else {
                onDone?.();
            }
        }, delay);
        return () => clearTimeout(timer);
    }, [currentStep, lastIndex, onDone]);

    return (
        <div className="upload-loading-wrap">
            <p className="upload-loading-title">Analyzing your manuscript</p>
            <div className="upload-loading-steps">
                {steps.map((text, i) => (
                    <div
                        key={i}
                        className={`upload-loading-step${i < currentStep ? " upl-done" : ""}${i === currentStep ? " upl-active" : ""}`}
                    >
                        <div className="upload-loading-icon">
                            {i < currentStep
                                ? <Check size={14} />
                                : i === currentStep
                                    ? <Loader2 size={14} className="upl-spin" />
                                    : <span className="upl-circle" />
                            }
                        </div>
                        <span className="upload-loading-text">{text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
